import { linkDynamicHTML } from './util';

export default ngModule => {
    ngModule.directive('corporateScript', (AonConfig) => {
        return {
            restrict: 'E',
            scope: {
                model: '=',
            },
            template: () => `<div>${AonConfig.corporate.end_of_application_script}</div>`,
            link: (scope) => {
                linkDynamicHTML(scope, AonConfig.corporate.end_of_application_script);
            }
        };
    });
}



// WEBPACK FOOTER //
// ./src/directives/corporate-script.js